import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import ApprovalsTableKntaiReturnModal from "../conponents/ApprovalsTableKntaiReturnModal";
import * as commonFnc from '../common/commonFnc';
import * as BL_approval from '../BL/BL_approval';
import {GlobalContext} from '../globalState'
import { Kintai_overtime } from "../classes/Kintai_overtime_class";
import { Box, Checkbox, Tooltip } from "@mui/material";
import ChangeShiftPriorityHighIcon from "./parts/ChangeShiftPriorityHighIcon";
import KintaiDitailModal from "./ApprovalsPage/kintaiDitailModal";
import VisibilityIcon from '@material-ui/icons/Visibility';
import isNextDate from "../util/isNextDate";


const formatCustomValue = (msec) =>{

    if(!msec) return "";

    const hours = Math.floor(msec / (1000 * 60 * 60));
    const minutes = Math.floor((msec % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours}:${minutes}`;

}

// name: ApprovalsTable
// summary: 【承認者用画面】承認待ち勤怠の一覧を表示する。
// prop: login_user_id
// prop: Kintai_bsc_this 対象の勤怠情報　Class名と被るため名称にthis
// prop: setKintai_bsc
// prop: Shift_msts
// prop: Department_msts
// prop: Users 
// prop: serchCondition
// prop: setSerchCondition
// prop: approval_kintai_bscs_view 承認一覧に表示する勤怠承認情報(承認者でのfiler後データ)
// prop: setApproval_kintai_bscs_view
// prop: setDisplay_user_info

const ApprovalsTable = (props) =>{
    // 01_props
    const {login_user_id,
            Kintai_bsc_this,
            setKintai_bsc,
            Shift_msts,
            Department_msts, 
            Users, 
            serchCondition,
            setSerchCondition, 
            setDisplay_user_info, 
            setRequest_overtimes, 
            setRequest_paid_holiday, 
            setAppcdCounter,
            filterApprovalStatusCd,
            viewIndex,
            APPROVAL_TABLE_VIEW_NUM,
            approval_kintai_bscs,
            setApproval_kintai_bscs,
            getApproval_kintai_bsc,
            loading,
            setLoading,
            setShiftStartDay
        } = props;

    // 02_useState
    const approvalTexts = useContext(GlobalContext).approvalTexts;

    const Env_msts = useContext(GlobalContext).Env_msts;
    const count1 = Env_msts.find(p=>p.env_key==="COUNT1");
    const count2 = Env_msts.find(p=>p.env_key==="COUNT2");
    const count3 = Env_msts.find(p=>p.env_key==="COUNT3");
    const count4 = Env_msts.find(p=>p.env_key==="COUNT4");
    const count5 = Env_msts.find(p=>p.env_key==="COUNT5");

    const custom1 = Env_msts.find(p=>p.env_key==="CUSTOM1");
    const custom2 = Env_msts.find(p=>p.env_key==="CUSTOM2");
    const custom3 = Env_msts.find(p=>p.env_key==="CUSTOM3");
    const custom4 = Env_msts.find(p=>p.env_key==="CUSTOM4");
    const custom5 = Env_msts.find(p=>p.env_key==="CUSTOM5");

    const IS_ENABLE_APPROVAL_MODAL = Env_msts.find(p=>p.env_key==="IS_ENABLE_APPROVAL_MODAL")?.env_bool;

    const history = useHistory();
    const [approval_kintai_bscs_view, setApproval_kintai_bscs_view] = useState([]);
    const [approvalReturnModalOpen, setApprovalReturnModalOpen] = useState(false);
    
    const [hidden_request_overtime_notes, setHidden_Request_overtime_notes] = useState(true);

    // 職員番号順に並び替え
    const [sortKey, setSortKey] = useState('date');
    // ソート順序を管理するstateを追加
    const [sortOrder, setSortOrder] = useState('asc'); // 'asc' または 'desc'

    var shiftHash = {};
    Shift_msts.map((Shift_mst) => (
        shiftHash[Shift_mst.shift_type_cd] = Shift_mst.shift_name
    ));

    
    var shiftColorHash = {};
    Shift_msts.map((Shift_mst) => (
        shiftColorHash[Shift_mst.shift_type_cd] = {
            backgroundcolor: Shift_mst.backgroundcolor,
            textcolor: Shift_mst.textcolor
        }
    ));

    var deptHash = {};
    Department_msts.map((dept) => (
        deptHash[dept.department_cd] = dept.name
    ));

    var userNameHash = {};
    Users.map((user) => (
        userNameHash[user.user_id] = user.first_name + " " + user.second_name
    ));

    // 03_独自関数(eventHandlerなど)

    // 承認情報変更：承認時等
    useEffect(()=>{
        reloadApprovalView();
    },[approval_kintai_bscs, filterApprovalStatusCd])

    const reloadApprovalView = async ()=>{

        if(approval_kintai_bscs.length > 0){

            let tmp_approval_kintai_bscs_view_filter = approval_kintai_bscs;
            
            if(serchCondition.target_deptgr_cd.length > 1){
                tmp_approval_kintai_bscs_view_filter = tmp_approval_kintai_bscs_view_filter.filter(item => item.user_info[0]?.organization_cd === serchCondition.target_deptgr_cd);
            }
            if(serchCondition.target_dept_cd.length > 1){
                tmp_approval_kintai_bscs_view_filter = tmp_approval_kintai_bscs_view_filter.filter(item => item.user_info[0]?.department_cd === serchCondition.target_dept_cd);
            }
            if(serchCondition.target_user_id.length > 0){
                tmp_approval_kintai_bscs_view_filter = tmp_approval_kintai_bscs_view_filter.filter(item => item.user_id === serchCondition.target_user_id);
            }
            if(serchCondition.target_user_name.length > 0){
                tmp_approval_kintai_bscs_view_filter = tmp_approval_kintai_bscs_view_filter.filter(item => userNameHash[item.user_id]?.indexOf(serchCondition.target_user_name)>-1);
            }
            if(serchCondition.target_shift_type_cd.length > 0){
                tmp_approval_kintai_bscs_view_filter = tmp_approval_kintai_bscs_view_filter.filter(item => item.shift_type_cd?.indexOf(serchCondition.target_shift_type_cd)>-1);
            }
            if(serchCondition.exist_over_time === 1){
                // 残業なしのみ
                tmp_approval_kintai_bscs_view_filter = tmp_approval_kintai_bscs_view_filter.filter(item => (item.over_time===null && item.midnight_over_time===null) || (item.over_time===undefined && item.midnight_over_time===undefined));
            }else if(serchCondition.exist_over_time === 2){
                // 残業ありのみ
                tmp_approval_kintai_bscs_view_filter = tmp_approval_kintai_bscs_view_filter.filter(item => item.over_time>0 || item.midnight_over_time>0);
            }
            if(serchCondition.changed_shift_type_only){
                tmp_approval_kintai_bscs_view_filter = tmp_approval_kintai_bscs_view_filter.filter(item => item.shift_type_cd_change_flg === true);
            }

            // 承認待ち件数を表示
            setAppcdCounter({
                count90: tmp_approval_kintai_bscs_view_filter.filter(item => item.approval_status_cd === "90").length,
                count80: tmp_approval_kintai_bscs_view_filter.filter(item => item.approval_status_cd === "80").length,
                count30: tmp_approval_kintai_bscs_view_filter.filter(item => item.approval_status_cd === "30").length,
                count20: tmp_approval_kintai_bscs_view_filter.filter(item => item.approval_status_cd === "20").length,
                count10: tmp_approval_kintai_bscs_view_filter.filter(item => item.approval_status_cd === "10").length,
            })

            tmp_approval_kintai_bscs_view_filter.forEach(obj => {
                obj.isExcludedForAllApproval = false; // 一括承認除外フラグを追加
            });

            setApproval_kintai_bscs_view(tmp_approval_kintai_bscs_view_filter);
                
        }else{
            setAppcdCounter({
                count90: 0,
                count80: 0,
                count30: 0,
                count20: 0,
                count10: 0,
            });
            setApproval_kintai_bscs_view([]);

        }

        
    }


    const moveRequestKintaiPage = ((Kintai_bsc) =>{
        setKintai_bsc(Kintai_bsc);

        // fechで取得するように変更する
        const query = new URLSearchParams({login_user_id: Kintai_bsc.user_id, date: commonFnc.formatDate(Kintai_bsc.date)});
        fetch(`/api/select/request_overtime?${query}`)
        .then((res) => res.json())
        .then((data) => {
            if(!data){
                setRequest_overtimes([new Kintai_overtime(Kintai_bsc)])
            }else{
                setRequest_overtimes(data)
            }
        });

        const queryRequest_paid_holiday = new URLSearchParams({login_user_id: Kintai_bsc.user_id, date: commonFnc.formatDate(Kintai_bsc.date)});
        fetch(`/api/select/request_paid_holiday?${queryRequest_paid_holiday}`)
        .then((res) => res.json())
        .then((data) => {
            if(!data){
                setRequest_paid_holiday({
                    request_paid_holiday_reason: "",
                })
            }else{
                setRequest_paid_holiday(data)
            }
        });

        let tmp_user = Users.find(item => item.user_id === Kintai_bsc.user_id);
        setDisplay_user_info(tmp_user);

        history.push('/RequestKintai');
    })

    // 承認ボタンクリック
    const handlerRequestButtonClick = async (target_kintai_bsc) =>{

        if(target_kintai_bsc.second_approval_userid === login_user_id 
            &&( target_kintai_bsc.approval_status_cd === "20"
            ||  target_kintai_bsc.approval_status_cd === "80")){

                var result = window.confirm('一次承認待ちの勤務です。繰り上げ承認しますか。');
                if( !result ) return;

        }
        await BL_approval.requestApproval("approval_kintai_bsc", target_kintai_bsc, Department_msts, setApproval_kintai_bscs, login_user_id);

        getApproval_kintai_bsc();
        
    };
    // 差戻ボタンクリック
    const handlerReturnButtonClick = (async(target_kintai_bsc) =>{
        await setKintai_bsc(target_kintai_bsc);
        setApprovalReturnModalOpen(true);
    });

    // 取り消しボタンクリック
    const handlerCancelButtonClick = async (target_kintai_bsc) =>{
            await BL_approval.requestCancel("approval_kintai_bsc", target_kintai_bsc, Department_msts, setApproval_kintai_bscs, login_user_id);
            getApproval_kintai_bsc();
    };
    
    // 名前ボタンクリック
    const handlerNameButtonClick = (user_name)=>{
        setSerchCondition({
            ...serchCondition,
            target_date_from : document.getElementById("target_date_from").value,
            target_date_to : document.getElementById("target_date_to").value,
            target_deptgr_cd : document.getElementsByName("target_deptgr_cd")[0].value,
            target_dept_cd : document.getElementsByName("target_dept_cd")[0].value,
            target_user_id : document.getElementById("target_user_id").value,
            target_user_name : user_name, 
        });
        getApproval_kintai_bsc();
        
    }


    // 進捗管理用
    const [progress, setProgress] = useState(0);
    const [allNum, setAllNum] = useState(0);
    const progressInitial = (allNum) =>{
        setAllNum(allNum);
    }
    const progressCountUp = (completedNum) =>{
        setProgress(completedNum);
    }
    const progressClear = (completedNum) =>{
        setProgress(0);
        setAllNum(0)
    }

    // 一括承認ボタンクリック
    const handlerAllRequestButtonClick = async () =>{

        var msg = "一括で承認しますか。完了までしばらくお待ちください。";
        if(existOtherApprovalUser(approval_kintai_bscs_view,login_user_id)){
            msg = "次回承認者があなたでは無い勤務はスキップします。" + msg;
        }

        var result = window.confirm(msg);
        if( result ) {

            const target_approval_kintai_bscs = approval_kintai_bscs_view
            .filter(p=>p.approval_status_cd===filterApprovalStatusCd)
            .slice(viewIndex, viewIndex+APPROVAL_TABLE_VIEW_NUM)
            .filter(p=>p.isExcludedForAllApproval===false); // 一括承認対象除外フラグがfalse

            // 進捗管理を開始
            let completed = 1;
            progressInitial(target_approval_kintai_bscs.length);

            const promises = target_approval_kintai_bscs.map(async (approval_kintai_bsc_view) => {
                if(approval_kintai_bsc_view.next_approval_userid === login_user_id){
                    await BL_approval.requestApproval("approval_kintai_bsc", approval_kintai_bsc_view, Department_msts, setApproval_kintai_bscs, login_user_id);
                    progressCountUp(completed += 1);
                }
            });
            
            await Promise.all(promises);
            getApproval_kintai_bsc();
            window.alert("一括承認が完了しました。");
            progressClear();

        }
    };
    
    // 一括取消ボタンクリック
    const handlerAllCancelButtonClick = async () =>{

        var msg = "前回承認者があなたでは無い勤務はスキップします。\n一括取消しますか。完了までしばらくお待ちください。";

        var result = window.confirm(msg);
        if( result ) {

            const target_approval_kintai_bscs = approval_kintai_bscs_view
            .filter(p=>p.approval_status_cd===filterApprovalStatusCd)
            .slice(viewIndex, viewIndex+APPROVAL_TABLE_VIEW_NUM)
            .filter(p=>p.isExcludedForAllApproval===false);        // 一括承認対象除外フラグがfalse
            
            // 進捗管理を開始
            let completed = 1;
            progressInitial(target_approval_kintai_bscs.length);

            const promises = target_approval_kintai_bscs.map(async (approval_kintai_bsc_view) => {
                if(approval_kintai_bsc_view.last_approval_userid === login_user_id){
                    await BL_approval.requestCancel("approval_kintai_bsc", approval_kintai_bsc_view, Department_msts, setApproval_kintai_bscs, login_user_id);
                    progressCountUp(completed += 1);
                }
            });
            
            await Promise.all(promises);
            getApproval_kintai_bsc();
            window.alert("一括取消が完了しました。");
            progressClear();

        }
    };

    const handleChangeHiddenFlg = ((setter, flg)=>{
        setter(!flg);
    })

    // 一括承認除外フラグの切替関数

    const handleChangeIsExcluded = (event, _id) => {
        const { name, checked } = event.target; // イベントから名前とチェック状態を取得
      
        setApproval_kintai_bscs_view((prevState) => {
          // 状態を更新
          const updatedKintai = prevState.map((kintai) => {
            if (kintai._id === _id) {
              return {
                ...kintai, // 元のオブジェクトをコピー
                [name]: checked, // 指定のプロパティを更新
              };
            }
            return kintai; // 一致しない場合はそのまま返す
          });
      
          return updatedKintai; // 更新後の配列を返す
        });
      };


    //  承認対象の勤怠の中に自分以外の承認者が含まれているか確認する。
    const existOtherApprovalUser = ((approval_kintai_bscs_view, user_id) => {

        var count = 0;
        approval_kintai_bscs_view
        .filter(p=>p.approval_status_cd===filterApprovalStatusCd)
        .slice(viewIndex, viewIndex+APPROVAL_TABLE_VIEW_NUM)
        .map((Kintai_bsc)=>{
            if(Kintai_bsc.next_approval_userid !== user_id){
                count++;
            }
        })

        return count > 0
    })

    const moveCalender = async (Kintai_bsc) => {
        
        // 勤怠一覧を初期化。遷移先で再取得
        // setKintai_bscs([]);   

        let tmp_user = Users.find(item => item.user_id === Kintai_bsc.user_id);
        setDisplay_user_info(tmp_user);

        var d = new Date(serchCondition.target_date_from);
        setShiftStartDay(d);    

        history.push('/Kintai');

    }

    // 職員番号順に並び替え
    const handleOnClickSortButton = (keyName) =>{
        
        // 同じキーをクリックした場合は昇順・降順を切り替え
        if (sortKey === keyName) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            // 異なるキーをクリックした場合は昇順にリセット
            setSortKey(keyName);
            setSortOrder('asc');
        }
    }

    const [modalOpen, setModalOpen] = useState(false);
    const [modalKintaiBsc, setModalKintaiBsc] = useState(null);
    const handleModalOpen = (Kintai_bsc) => {
        if(IS_ENABLE_APPROVAL_MODAL){
            setModalKintaiBsc(Kintai_bsc);
            setModalOpen(true);
        }
    }
    const handleModalClose = () => {
        setModalOpen(false);
        setModalKintaiBsc(null);
    }

    // ソートアイコンを表示する関数を修正
    const getSortIcon = (keyName) => {
        if (sortKey === keyName) {
            return <span style={style.sortIcon}>{sortOrder === 'asc' ? '▲' : '▼'}</span>;
        }
        return <span style={style.sortIcon}>⇅</span>;
    };

    const tableRowStyle = (isExcludedForAllApproval) =>{
        return (
            {
                backgroundColor: isExcludedForAllApproval?'lightGray':'snow'
            }
        )
    }

    const style = {
        tableRow:tableRowStyle,
        tableHeaderCellBase:{
            fontSize:'0.8rem',
            padding:'3px',
            "& .MuiTableCell-root": { padding: "8px" }
        },
        // ソート可能なヘッダーセルのスタイルを修正
        sortableHeaderCell: {
            cursor: 'pointer',
            userSelect: 'none',
            // position: 'relative' を削除してstickyを維持
            transition: 'all 0.2s ease',
            '&:hover': {
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            },
            '&:active': {
                transform: 'translateY(0)',
                boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
            }
        },
        // ソートアイコンのスタイル
        sortIcon: {
            marginLeft: '4px',
            fontSize: '0.7rem',
            opacity: 0.7,
            // アイコンをインライン要素として配置
            display: 'inline-block'
        },
        tableCellNote:{
            maxWidth: '100px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            position: 'relative',
            padding:'10px',
        },
        linkButton:{
            fontSize:'0.8rem',
            color:'blue'
        },
        approvalButton:{
            fontSize:'0.8rem',
            padding:'1px'
        },
        allApprovalButton:{
            fontSize:'0.6rem',
            padding:'1px',
            margin:'1px'
        },
        visibilityIcon:{
            color:"lightgray",
            margin:'0px 5px'
        }
    }

    return (
        <div className={progress?"loading-wrapper":false}>
            {progress?
            <div class="loading-center">
                <div class="loader">Loading...</div>
                <div>処理済み: {`${progress}/${allNum}`}</div>
            </div>:<></>
            }
            {loading ? <div class="loader">Loading...</div> :
            <TableContainer component={Paper} style={{ maxHeight: '65vh'}}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell 
                                align="center" 
                                style={{
                                    ...style.tableHeaderCellBase, 
                                    ...style.sortableHeaderCell,
                                    minWidth:100, 
                                    borderBottom: sortKey==='date'?'2px solid #1976d2':''
                                }} 
                                onClick={()=>handleOnClickSortButton('date')}
                            >
                                日付{getSortIcon('date')}
                            </TableCell>
                            {IS_ENABLE_APPROVAL_MODAL && 
                            <TableCell align="center" style={{...style.tableHeaderCellBase}}>
                                <VisibilityIcon style={style.visibilityIcon}/>
                            </TableCell>
                            }
                            <TableCell 
                                align="center" 
                                style={{
                                    ...style.tableHeaderCellBase, 
                                    ...style.sortableHeaderCell,
                                    minWidth:100, 
                                    borderBottom: sortKey==='organization_cd'?'2px solid #1976d2':''
                                }} 
                                onClick={()=>handleOnClickSortButton('organization_cd')}
                            >
                                施設名{getSortIcon('organization_cd')}
                            </TableCell>
                            <TableCell 
                                align="center" 
                                style={{
                                    ...style.tableHeaderCellBase, 
                                    ...style.sortableHeaderCell,
                                    minWidth:100, 
                                    borderBottom: sortKey==='department_cd'?'2px solid #1976d2':''
                                }} 
                                onClick={()=>handleOnClickSortButton('department_cd')}
                            >
                                部署名{getSortIcon('department_cd')}
                            </TableCell>
                            <TableCell 
                                align="center" 
                                style={{
                                    ...style.tableHeaderCellBase, 
                                    ...style.sortableHeaderCell,
                                    minWidth:100, 
                                    borderBottom: sortKey==='user_id'?'2px solid #1976d2':''
                                }} 
                                onClick={()=>handleOnClickSortButton('user_id')}
                            >
                                職員番号{getSortIcon('user_id')}
                            </TableCell>
                            <TableCell 
                                align="center" 
                                style={{
                                    ...style.tableHeaderCellBase, 
                                    ...style.sortableHeaderCell,
                                    minWidth:100, 
                                    borderBottom: sortKey==='name'?'2px solid #1976d2':''
                                }} 
                                onClick={()=>handleOnClickSortButton('name')}
                            >
                                氏名{getSortIcon('name')}
                            </TableCell>
                            <TableCell 
                                align="center" 
                                style={{
                                    ...style.tableHeaderCellBase, 
                                    ...style.sortableHeaderCell,
                                    minWidth:80, 
                                    borderBottom: sortKey==='shift_type_cd'?'2px solid #1976d2':''
                                }} 
                                onClick={()=>handleOnClickSortButton('shift_type_cd')}
                            >
                                シフト{getSortIcon('shift_type_cd')}
                            </TableCell>
                            <TableCell align="center" style={{...style.tableHeaderCellBase}} >開始時間</TableCell>
                            <TableCell align="center" style={{...style.tableHeaderCellBase}} >終了時間</TableCell>
                            <TableCell align="center" style={{...style.tableHeaderCellBase}} >時間</TableCell>
                            <TableCell align="center" style={{...style.tableHeaderCellBase}} >休憩</TableCell>
                            <TableCell 
                                align="center" 
                                style={{...style.tableHeaderCellBase}} 
                                onClick={()=>handleChangeHiddenFlg(setHidden_Request_overtime_notes, hidden_request_overtime_notes)}
                                >
                                <span className="link">時間外</span>
                            </TableCell>
                            <TableCell align="center" style={{...style.tableHeaderCellBase}} >深夜</TableCell>
                            {hidden_request_overtime_notes ? "" :
                                <TableCell>残業理由</TableCell>
                            }
                            <TableCell align="center" style={{...style.tableHeaderCellBase}} >遅刻</TableCell>
                            <TableCell align="center" style={{...style.tableHeaderCellBase}} >早退</TableCell>
                            <TableCell align="center" style={{...style.tableHeaderCellBase}} >外出</TableCell>
                            <TableCell align="center" style={{...style.tableHeaderCellBase}} >業務外</TableCell>
                            {count1?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{count1?.env_value.substr( 0, 4 )}</TableCell>}
                            {count2?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{count2?.env_value.substr( 0, 4 )}</TableCell>}
                            {count3?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{count3?.env_value.substr( 0, 4 )}</TableCell>}
                            {count4?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{count4?.env_value.substr( 0, 4 )}</TableCell>}
                            {count5?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{count5?.env_value.substr( 0, 4 )}</TableCell>}

                            {custom1?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{custom1?.env_value.substr( 0, 4 )}</TableCell>}
                            {custom2?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{custom2?.env_value.substr( 0, 4 )}</TableCell>}
                            {custom3?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{custom3?.env_value.substr( 0, 4 )}</TableCell>}
                            {custom4?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{custom4?.env_value.substr( 0, 4 )}</TableCell>}
                            {custom5?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{custom5?.env_value.substr( 0, 4 )}</TableCell>}
                            <TableCell align="center" style={{...style.tableHeaderCellBase}}>備考</TableCell>
                            <TableCell align="center" style={{...style.tableHeaderCellBase}}>差戻理由</TableCell>
                            <TableCell align="center" style={{...style.tableHeaderCellBase, minWidth:100}}>次回承認</TableCell>
                            <TableCell align="center" style={{...style.tableHeaderCellBase}}>一括除外</TableCell>
                            <TableCell style={{...style.tableHeaderCellBase}} >
                                <Box sx={{width:'150px'}}>
                                    <div>
                                    <Button 
                                        style={style.allApprovalButton}
                                        variant="outlined" 
                                        color="primary" 
                                        onClick={()=>handlerAllRequestButtonClick()}>
                                        一括承認
                                    </Button>
                                    </div>
                                    <div>
                                    <Button 
                                        style={style.allApprovalButton}
                                        variant="outlined" 
                                        color="primary" 
                                        onClick={()=>handlerAllCancelButtonClick()}>
                                        一括取消
                                    </Button>
                                    </div>
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {approval_kintai_bscs_view.filter(p=>p.approval_status_cd===filterApprovalStatusCd).sort((a, b) => {
                            const key = sortKey
                            let comparison = 0;
                            
                            if(sortKey==='name'){
                                comparison = userNameHash[a['user_id']]?.localeCompare(userNameHash[b['user_id']]); // 辞書順
                            }else if(sortKey==='organization_cd'){
                                comparison = deptHash[a.user_info[0]['organization_cd']]?.localeCompare(deptHash[b.user_info[0]['organization_cd']]); // 辞書順
                            }else if(sortKey==='department_cd'){
                                comparison = deptHash[a.user_info[0]['department_cd']]?.localeCompare(deptHash[b.user_info[0]['department_cd']]); // 辞書順
                            } else {
                                comparison = a[key]?.localeCompare(b[key]); // 辞書順
                            }
                            
                            // 降順の場合は比較結果を反転
                            return sortOrder === 'desc' ? -comparison : comparison;
                        }).slice(viewIndex, viewIndex+APPROVAL_TABLE_VIEW_NUM).map((Kintai_bsc, index)=>(
                            <TableRow key={index} style={style.tableRow(Kintai_bsc.isExcludedForAllApproval)} onDoubleClick={()=>handleModalOpen(Kintai_bsc)}>
                                <TableCell style={{...style.tableHeaderCellBase}} component="th" scope="row">
                                    <Button variant="outlined" color="primary" onClick={(e)=>moveRequestKintaiPage(Kintai_bsc)}
                                        value={commonFnc.ConvertJST(Kintai_bsc.date).split(' ')[0]}>
                                        {commonFnc.ConvertJST(Kintai_bsc.date).split(' ')[0]
                                        + "(" + [ "日", "月", "火", "水", "木", "金", "土" ][(new Date(Kintai_bsc.date)).getDay()] + ")"}
                                    </Button>
                                </TableCell>
                                {IS_ENABLE_APPROVAL_MODAL && 
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>
                                    <VisibilityIcon onClick={()=>handleModalOpen(Kintai_bsc)} style={style.visibilityIcon}/>
                                </TableCell>
                                }
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>{deptHash[Kintai_bsc.user_info[0]?.organization_cd]}</TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>{deptHash[Kintai_bsc.user_info[0]?.department_cd]}</TableCell>
                                {/* <TableCell align="center">{Kintai_bsc.user_id}</TableCell> */}
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}><Button style={style.linkButton} onClick={()=>moveCalender(Kintai_bsc)}>{Kintai_bsc.user_id}</Button></TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}><Button style={style.linkButton} onClick={()=>handlerNameButtonClick(userNameHash[Kintai_bsc.user_id])}>{userNameHash[Kintai_bsc.user_id]}</Button></TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>
                                    <Box sx={{display:"flex"}}>
                                    <div style={{width:"100%"}}>
                                        <div 
                                            className={"shift_type"} 
                                            style={{
                                                backgroundColor: Kintai_bsc.shift_type_cd ? shiftColorHash[Kintai_bsc.shift_type_cd]?.backgroundcolor:"transparent" ,
                                                color: Kintai_bsc.shift_type_cd ? shiftColorHash[Kintai_bsc.shift_type_cd]?.textcolor:"",
                                                width:'100%'
                                            }}
                                        >
                                            {shiftHash[Kintai_bsc.shift_type_cd]?shiftHash[Kintai_bsc.shift_type_cd]:"-"}
                                        </div>
                                        
                                        {Kintai_bsc.harf_holiday_shift_type_cd?
                                        <div className={"shift_type"} style={{backgroundColor: Kintai_bsc.harf_holiday_shift_type_cd ? shiftColorHash[Kintai_bsc.harf_holiday_shift_type_cd]?.backgroundcolor:"" ,color: Kintai_bsc.harf_holiday_shift_type_cd ? shiftColorHash[Kintai_bsc.harf_holiday_shift_type_cd]?.textcolor:""}}>
                                            {shiftHash[Kintai_bsc.harf_holiday_shift_type_cd]}
                                        </div>
                                        :""}
                                        {Kintai_bsc.paid_holiday_shift_type_cd?
                                        <div className={"shift_type"} style={{backgroundColor: Kintai_bsc.paid_holiday_shift_type_cd ? shiftColorHash[Kintai_bsc.paid_holiday_shift_type_cd]?.backgroundcolor:"" ,color: Kintai_bsc.paid_holiday_shift_type_cd ? shiftColorHash[Kintai_bsc.paid_holiday_shift_type_cd]?.textcolor:""}}>
                                            {shiftHash[Kintai_bsc.paid_holiday_shift_type_cd]}
                                        </div>
                                        :""}
                                    </div>
                                    {
                                        Kintai_bsc.shift_type_cd_change_flg ? <ChangeShiftPriorityHighIcon /> :<></>
                                    }
                                    </Box>
                                </TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>
                                    <span>{isNextDate(Kintai_bsc.date,Kintai_bsc.work_time_from) ? "翌" : ""}{commonFnc.ConvertJSTHHMM(Kintai_bsc.work_time_from)}</span>
                                    <span class="helper_clockin_time"><br/>{(!Kintai_bsc.clockin_info.find(p=>p.clockin_type_cd==="10")?.maxTime ? "": Kintai_bsc.clockin_info.find(p=>p.clockin_type_cd==="10")?.maxTime)}</span>
                                </TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>
                                    <span>{isNextDate(Kintai_bsc.date,Kintai_bsc.work_time_to) ? "翌" : ""}{commonFnc.ConvertJSTHHMM(Kintai_bsc.work_time_to)}</span>
                                    <span class="helper_clockin_time"><br/>{(!Kintai_bsc.clockin_info.find(p=>p.clockin_type_cd==="90")?.maxTime ? "": Kintai_bsc.clockin_info.find(p=>p.clockin_type_cd==="90")?.maxTime)}</span>
                                </TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>{!Kintai_bsc.work_time ? "" : commonFnc.getHHmm(Kintai_bsc.work_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>{!Kintai_bsc.rest_time ? "" : commonFnc.getHHmm(Kintai_bsc.rest_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>{!Kintai_bsc.over_time ? "" : commonFnc.getHHmm(Kintai_bsc.over_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>{!Kintai_bsc.midnight_over_time ? "" : commonFnc.getHHmm(Kintai_bsc.midnight_over_time)}</TableCell>
                                {hidden_request_overtime_notes ? "" :
                                    <TableCell align="center" style={{...style.tableHeaderCellBase}}>{!Kintai_bsc.user_id ? "" : Kintai_bsc.over_time_info[0]?.reason}</TableCell>
                                }
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>{!Kintai_bsc.behind_time ? "" : commonFnc.getHHmm(Kintai_bsc.behind_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>{!Kintai_bsc.early_time ? "" : commonFnc.getHHmm(Kintai_bsc.early_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>{!Kintai_bsc.out_time ? "" : commonFnc.getHHmm(Kintai_bsc.out_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>{!Kintai_bsc.training_time ? "" : commonFnc.getHHmm(Kintai_bsc.training_time)}</TableCell>
                                {count1?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{Kintai_bsc.count1 ? count1?.env_value.substr( 0, 1 ) : ""}</TableCell>}
                                {count2?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{Kintai_bsc.count2 ? count2?.env_value.substr( 0, 1 ) : ""}</TableCell>}
                                {count3?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{Kintai_bsc.count3 ? count3?.env_value.substr( 0, 1 ) : ""}</TableCell>}
                                {count4?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{Kintai_bsc.count4 ? count4?.env_value.substr( 0, 1 ) : ""}</TableCell>}
                                {count5?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{Kintai_bsc.count5 ? count5?.env_value.substr( 0, 1 ) : ""}</TableCell>}
                                {custom1?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{Kintai_bsc.custom1 ? formatCustomValue(Kintai_bsc.custom1) : ""}</TableCell>}
                                {custom2?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{Kintai_bsc.custom2 ? formatCustomValue(Kintai_bsc.custom2) : ""}</TableCell>}
                                {custom3?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{Kintai_bsc.custom3 ? formatCustomValue(Kintai_bsc.custom3) : ""}</TableCell>}
                                {custom4?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{Kintai_bsc.custom4 ? formatCustomValue(Kintai_bsc.custom4) : ""}</TableCell>}
                                {custom5?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableHeaderCellBase}}>{Kintai_bsc.custom5 ? formatCustomValue(Kintai_bsc.custom5) : ""}</TableCell>}
                                <TableCell align="center" style={{...style.tableHeaderCellBase, ...style.tableCellNote}}>
                                    <Tooltip title={Kintai_bsc.kintai_note} placement="top">
                                        {!Kintai_bsc.kintai_note ? "" : Kintai_bsc.kintai_note}
                                    </Tooltip>
                                </TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>{!Kintai_bsc.approval_note ? "" : Kintai_bsc.approval_note}</TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>{!Kintai_bsc.next_approval_userid ? "" : userNameHash[Kintai_bsc.next_approval_userid]}</TableCell>
                                <TableCell align="center" style={{...style.tableHeaderCellBase}}>
                                    <Checkbox
                                        size="small"
                                        key={`checkbox-${index}`} // 一意な key を設定
                                        name="isExcludedForAllApproval"
                                        checked={Kintai_bsc.isExcludedForAllApproval}
                                        onChange={(e)=>handleChangeIsExcluded(e, Kintai_bsc._id)}
                                    />
                                    <Box style={{fontSize:'0.6rem'}}>{Kintai_bsc.isExcludedForAllApproval?'一括除外':''}</Box>
                                </TableCell>
                                {Kintai_bsc.last_approval_userid === login_user_id ?
                                    <TableCell style={{...style.tableHeaderCellBase}}>
                                        <Box sx={{width:'150px'}}>
                                            <Box sx={{margin:'0 auto'}}>
                                                <Button variant="outlined" color="primary" 
                                                    onClick={(e)=>handlerCancelButtonClick(Kintai_bsc)}>
                                                    取消
                                                </Button>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                    : 
                                    <TableCell style={{...style.tableHeaderCellBase}}>
                                        <Box sx={{width:'150px'}}>
                                            <Box sx={{margin:'0 auto'}}>
                                                <Button 
                                                    style={style.approvalButton}
                                                    variant="outlined"
                                                    color="primary" 
                                                    disabled={!(Kintai_bsc.next_approval_userid === login_user_id || Kintai_bsc.second_approval_userid === login_user_id)}
                                                    onClick={(e)=>handlerRequestButtonClick(Kintai_bsc)}>
                                                    承認
                                                </Button>
                                            </Box>
                                            <Box sx={{margin:'0 auto'}}>
                                                <Button
                                                    style={style.approvalButton}
                                                    variant="outlined"
                                                    color="primary" 
                                                    disabled={!(Kintai_bsc.next_approval_userid === login_user_id || Kintai_bsc.second_approval_userid === login_user_id)}
                                                    onClick={(e)=>handlerReturnButtonClick(Kintai_bsc)}>
                                                    差戻
                                                </Button>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                }
                            </TableRow>
                        ))}
                        <ApprovalsTableKntaiReturnModal
                
                            Kintai_bsc={Kintai_bsc_this}
                            setKintai_bsc={setKintai_bsc}
                            approvalReturnModalOpen={approvalReturnModalOpen}
                            setApprovalReturnModalOpen={setApprovalReturnModalOpen}
                            Department_msts={Department_msts}
                            setApproval_kintai_bscs={setApproval_kintai_bscs}
                            login_user_id={login_user_id}
                            urlPrefix="approval_kintai_bsc"
                            getApproval_kintai_bsc={getApproval_kintai_bsc}
                        >
                        </ApprovalsTableKntaiReturnModal>
                        <KintaiDitailModal
                            kintai_bsc={modalKintaiBsc}
                            userName={userNameHash[modalKintaiBsc?.user_id]}
                            modalOpen={modalOpen}
                            handleModalClose={handleModalClose}
                            shiftMst={Shift_msts}
                        >
                        </KintaiDitailModal>
                    </TableBody>
                </Table>
            </TableContainer>
            }
        </div>
    );
}
export default ApprovalsTable;